module.exports = __webpack_public_path__ + "static/microsoft-partner-a0b8adbbfc1c668d202b83693faa7cef.png";